"use client";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { OmniSearch } from "./search";

type Props = {
  visible: boolean;
  onClose: () => void;
};

export function OmniSearchModal({ visible, onClose }: Props) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!visible || !mounted) return null;

  return createPortal(
    <div
      className="fixed inset-0 flex justify-center items-start pt-[30px] px-[15px]"
      style={{ zIndex: 9999 }}
      onClick={onClose}
    >
      <div
        className="absolute inset-0"
        style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
        aria-hidden="true"
      />
      <div
        className="relative w-full max-w-[720px]"
        style={{ zIndex: 1 }}
        onClick={(e) => e.stopPropagation()}
      >
        <OmniSearch />
      </div>
    </div>,
    document.body,
  );
}
